export default "__VITE_ASSET__BJ1Gu3dd__ 480w, __VITE_ASSET__DEiun5w9__ 800w, __VITE_ASSET__BRjWQlSR__ 1067w";